import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import * as utils from '../../shared/helpers/utils';
import { User } from '../models/user.model';
import { Groups } from '../models/group.model';
import { Location } from '@angular/common';
import { EntityService } from '../services/entity.service';

export const authGuard: CanActivateFn = async (route, state) => {

  const router = inject(Router);
  const location = inject(Location);
  const entityService = inject(EntityService);
  const user: User = utils?.localStorageGetItem('user');

  if (user) {
    if (state.url.includes('login')) {
      let destination = state.url.includes('login') ? 'entities' : null;
      if (user.roleId === 4) {
        try {
          const groups = new Groups();
          const res = await firstValueFrom(entityService.getEntityApps(user.entityId));
          if (groups.showDashboard(res)) destination = 'dashboard';
        } catch (e) { console.error('[authGuard] getEntityApps error:', e); }
      }
      if (destination) {
        router.navigate([destination], { queryParams: route.queryParams });
        return false;
      }
      return true;
    } else if (state.url.includes('/fits/error') && user.roleId !== 1) {
      // solo el admin ve los errores de fit
      location.back();
      return false;
    } else if (state.url.includes('/devices') && user.roleId === 4) {
      // las oficinas no pueden ver devices
      location.back();
      return false;
    } else if (state.url.includes('/admin-tools') && !(user.roleId === 1 && user.profileId === 3)) {
      // solo superadmin puede acceder a admin-tools
      location.back();
      return false;
    } else {
      return true;
    }
  } else {
    if (!state.url.includes('login')) {
      router.navigate(['login'], { queryParams: route.queryParams });
      return false;
    } else {
      return true;
    }
  }

};
